module.exports = __webpack_public_path__ + "img/w_js@2x.156d4277.png";